import * as React from 'react';
import { IconButton, Tooltip } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';

interface Props {
  type?: 'clicked' | 'unclicked';
  id?: string;
  iconSize?: number;
  size?: string;
  onClick?: () => void;
}

const ApproveDataIcon: React.FC<Props> = ({ type = 'unclicked', id, onClick, size = 'lg' }) => {
  const buttonProps = () => {
    if (type === 'clicked') {
      return {
        isActive: true,
        colorScheme: 'green',
      };
    }
    return null;
  };

  return (
    <>
      <Tooltip hasArrow placement="top" label="Confirm">
        <IconButton
          data-selector={id}
          onClick={onClick}
          aria-label="Confirm"
          icon={<FontAwesomeIcon id={id || 'icon'} icon={faCheck} />}
          size={size}
          {...buttonProps()}
        />
      </Tooltip>
    </>
  );
};

export { ApproveDataIcon };
